//session, local storage 데이터 함수 처리

import {
  HAS_CLOSED_PROFILE_FILL_REQUEST_KEY,
  HAS_CLOSED_STARTUP_CHATTING_GUIDE_KEY,
  HAS_CLOSED_USER_CHATTING_GUIDE_KEY,
  HIDE_APP_INSTALL_PROMPT_POP_UP,
  HIDE_NATURAL_LANGUAGE_BETA_NOTICE_KEY,
  HIDE_PENALTY_NOTICE_STORAGE_KEY,
  HIDE_SCOUT_PAGE_NOTICE,
  HIDE_STARTUP_DETAIL_FORM_GUIDE_KEY,
  HIDE_STARTUP_POSITION_FORM_GUIDE_KEY,
  HIDE_PROFILE_FILL_NEED_MODAL_KEY,
  SKIP_POSITION_APPLICATION_CONTACT_KEY,
  SKIP_POSITION_APPLICATION_PREVIEW_KEY,
  IS_HIDE_RECOMMENDED_GUIDE_BOX_KEY,
  AI_ASSESSMENT_NOTICE_POP_UP_KEY,
  AI_ASSESSMENT_CONDITIONS_KEY,
  PRE_INTERVIEW_FAIL_REASON_TOOLTIP_KEY,
  COFFEE_CHAT_NOTICE_STORAGE_KEY,
  PROPOSAL_AUTO_CHECKED_FULFILLMENTS_KEY,
  DASHBOARD_RECOMMENDED_GUIDE_BOX_KEY,
  ZIGHANG_USER_STORAGE_KEY,
} from 'infra/constants'
import { HidePenaltyNoticeType } from 'types/common'

type EnvelopeStorage<T> = T | null

export const getClosedProfileFillRequestStorage = () =>
  JSON.parse(
    localStorage.getItem(HAS_CLOSED_PROFILE_FILL_REQUEST_KEY) as string,
  ) as EnvelopeStorage<number[]>

export const getHidePenaltyNoticeStorage = () =>
  JSON.parse(
    localStorage.getItem(HIDE_PENALTY_NOTICE_STORAGE_KEY) as string,
  ) as EnvelopeStorage<{
    type: HidePenaltyNoticeType
    expire: number
  }>

export const getUserChattingGuideStorage = () =>
  JSON.parse(
    localStorage.getItem(HAS_CLOSED_USER_CHATTING_GUIDE_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getStartupChattingGuideStorage = () =>
  JSON.parse(
    localStorage.getItem(HAS_CLOSED_STARTUP_CHATTING_GUIDE_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getStartupDetailFormGuideStorage = () =>
  JSON.parse(
    localStorage.getItem(HIDE_STARTUP_DETAIL_FORM_GUIDE_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getStartupPositionFormGuideStorage = () =>
  JSON.parse(
    localStorage.getItem(HIDE_STARTUP_POSITION_FORM_GUIDE_KEY) as string,
  ) as EnvelopeStorage<{ expire: number }>

export const getNaturalLanguageInputBetaNoticeStorage = () =>
  JSON.parse(
    localStorage.getItem(HIDE_NATURAL_LANGUAGE_BETA_NOTICE_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getScoutPageNoticeStore = () =>
  JSON.parse(localStorage.getItem(HIDE_SCOUT_PAGE_NOTICE) as string)

export const getProfileFillNeedModalStorage = () =>
  JSON.parse(
    localStorage.getItem(HIDE_PROFILE_FILL_NEED_MODAL_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getAppInstallPromptPopUpStorage = () =>
  JSON.parse(
    localStorage.getItem(HIDE_APP_INSTALL_PROMPT_POP_UP) as string,
  ) as EnvelopeStorage<boolean>

export const getPositionApplicationContactSkipStorage = () =>
  JSON.parse(
    localStorage.getItem(SKIP_POSITION_APPLICATION_CONTACT_KEY) as string,
  ) as EnvelopeStorage<{ expire: number }>

export const getPositionApplicationPreviewSkipStorage = () =>
  JSON.parse(
    localStorage.getItem(SKIP_POSITION_APPLICATION_PREVIEW_KEY) as string,
  ) as EnvelopeStorage<{ expire: number }>

export const getIsHideRecommendedGuideBoxStorage = () =>
  JSON.parse(
    localStorage.getItem(IS_HIDE_RECOMMENDED_GUIDE_BOX_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getPreInterviewFailReasonTooltipStorage = () =>
  JSON.parse(
    localStorage.getItem(PRE_INTERVIEW_FAIL_REASON_TOOLTIP_KEY) as string,
  ) as EnvelopeStorage<number[]>

export const getMarketingContentSharedStorage = (storageKey: string) =>
  JSON.parse(localStorage.getItem(storageKey) as string) as EnvelopeStorage<{
    id: string
    isShared: boolean
  }>

export const getAiAssessmentNoticePopUpStorage = () =>
  JSON.parse(
    localStorage.getItem(AI_ASSESSMENT_NOTICE_POP_UP_KEY) as string,
  ) as EnvelopeStorage<{ expire: number }>

export const getAiAssessmentNoticeConditionStorage = (id: Number) =>
  JSON.parse(
    localStorage.getItem(AI_ASSESSMENT_CONDITIONS_KEY + `_${id}`) as string,
  ) as EnvelopeStorage<string[]>

export const getCoffeeChatNoticeStorage = () =>
  JSON.parse(
    localStorage.getItem(COFFEE_CHAT_NOTICE_STORAGE_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getProposalAutoCheckedFulfillments = (id: Number) =>
  JSON.parse(
    localStorage.getItem(
      PROPOSAL_AUTO_CHECKED_FULFILLMENTS_KEY + `_${id}`,
    ) as string,
  ) as EnvelopeStorage<string[]>

export const getRecommendedGuideBox = () =>
  JSON.parse(
    localStorage.getItem(DASHBOARD_RECOMMENDED_GUIDE_BOX_KEY) as string,
  ) as EnvelopeStorage<boolean>

export const getZighangUserStorage = () =>
  JSON.parse(
    localStorage.getItem(ZIGHANG_USER_STORAGE_KEY) as string,
  ) as EnvelopeStorage<{
    client_id: string
    utm_medium: string
    utm_source: string
    zighang_source_url: string
    careerTypes?: string[] | string
    positionTypes?: string[] | string
    serviceAreas?: string[] | string
    locations?: string[] | string
  }>
